"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const metadata_1 = require("./metadata");
const serializer_factory_1 = require("./serializers/serializer_factory");
const defaultOptions = {
    optional: false,
    nullable: false
};
/** Serialize property with default serializer */
function Serialize(options) {
    return (target, propertyName) => {
        const mergedOptions = options ? Object.assign({}, defaultOptions, options) : defaultOptions;
        const serializer = serializer_factory_1.default.createFor(target, propertyName, mergedOptions);
        metadata_1.default.getOrCreateFor(target).props.set(propertyName, serializer);
    };
}
(function (Serialize) {
    /** Serialize property with custom serializer */
    function Custom(serializer) {
        return (target, propertyName, propertyDescriptor) => {
            metadata_1.default.getOrCreateFor(target).props.set(propertyName, serializer);
        };
    }
    Serialize.Custom = Custom;
})(Serialize || (Serialize = {}));
exports.default = Serialize;
//# sourceMappingURL=serialize.js.map